cb.define([], function () {
  var AA_aa_businesstype_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
        var self = this;
      if(viewmodel.getParams().mode=="add" )
      {
        var pselectcode,pselectname,pselectid;
        pselectcode=viewmodel.getParams().parent.code;
        pselectname=viewmodel.getParams().parent.name;
        pselectid=viewmodel.getParams().parent.id;
        //根据父节点 选中节点赋值
        viewmodel.get("receipttype_name").setValue(pselectname);
        viewmodel.get("receipttype").setValue(pselectid);
        viewmodel.get("MinPercentGiveMoneyPre").setValue("100");
      }
     
      viewmodel.on("beforeDelete",function(data) {
        if(viewmodel.get("isSystem").getValue())
        {
         cb.utils.alert('预置数据不能删除','warning');
         return false;
        }
      });
      viewmodel.on("beforeEdit",function(data) {
        self.setEditItemDisabled(viewmodel);
        viewmodel.get("btnEdit").setVisible(false);
        viewmodel.get("btnDelete").setVisible(false);
        viewmodel.get("btnAbandonBrowst").setVisible(false);
         viewmodel.get("btnSave").setVisible(true);
         viewmodel.get("btnAbandon").setVisible(true);
      });
      viewmodel.on("beforeSave",function(data) {
        var retbool=true;
        
        if(viewmodel.getParams().mode=="edit")
        {

             retbool=self.setCheckMustInput( viewmodel.get("receipttype_code").getValue(),viewmodel);
        }
        else{

                 retbool=self.setCheckMustInput(viewmodel.getParams().parent.code,viewmodel);
        }
        if(!retbool){
          return retbool;
        }
        return self.setMinPercentGiveMoneyRang(viewmodel.get('MinPercentGiveMoneyPre').getValue(),viewmodel);
      });
    
      viewmodel.on("beforeSaveandadd",function(data) {
        var retbool=true;
        
        if(viewmodel.getParams().mode=="edit")
        {

             retbool=self.setCheckMustInput( viewmodel.get("receipttype_code").getValue(),viewmodel);
        }
        else{

                 retbool=self.setCheckMustInput(viewmodel.getParams().parent.code,viewmodel);
        }
        if(!retbool){
          return retbool;
        }
        return self.setMinPercentGiveMoneyRang(viewmodel.get('MinPercentGiveMoneyPre').getValue(),viewmodel);
      });
       viewmodel.on("afterLoadData",function(data) {
         var pselectcode,pselectname,pselectid;
         var showbtn=false ;
         //viewmodel.getParams().mode  "edit"   add
         viewmodel.get("btnEdit").setVisible(false);
         viewmodel.get("btnDelete").setVisible(false);

         viewmodel.get("btnAbandonBrowst").setVisible(false);
         viewmodel.get("btnSave").setVisible(true);
         viewmodel.get("btnAbandon").setVisible(true);
         if(viewmodel.getParams().mode=="browse" )
         {
           showbtn=false;
           viewmodel.get("btnEdit").setVisible(true);
           viewmodel.get("btnDelete").setVisible(true);
           viewmodel.get("btnAbandonBrowst").setVisible(true);
           viewmodel.get("btnSave").setVisible(false);
           viewmodel.get("btnAbandon").setVisible(false);
           
         }
         if(viewmodel.getParams().mode=="add" )
         {
              showbtn=true;
              pselectcode=viewmodel.getParams().parent.code;
              pselectname=viewmodel.getParams().parent.name;
              pselectid=viewmodel.getParams().parent.id;
              //根据父节点 选中节点赋值
              viewmodel.get("receipttype_name").setValue(pselectname);
              viewmodel.get("receipttype").setValue(pselectid);
              if(pselectcode=="A01"){
                viewmodel.get("MinPercentGiveMoneyPre").setValue("100");
                viewmodel.get("storeType").setValue("1,2");
              }
              if(pselectcode== "A07"|| pselectcode== "A08"){
                viewmodel.get("isSaveAndAudit").setValue(true);
              }
              if(pselectcode=="A15"){
                
                viewmodel.get("bPurchaseAmountSend").setValue(false);
              }

         }
         if(viewmodel.getParams().mode=="edit" )
         {
         // viewmodel.get("code").setDisabled(true);
          //viewmodel.get("name").setDisabled(true);
          self.setEditItemDisabled(viewmodel);

         }
         if(viewmodel.get("receipttype_code").getValue()!=undefined )
         {
           pselectcode=viewmodel.get("receipttype_code").getValue()
         }
         
         viewmodel.get("btnSaveAndAdd").setVisible(showbtn);
         
           //根据单据类型设置显示
          self.setItemVisible(pselectcode,viewmodel)
         if(pselectcode=="A01")
         {
           //如果是零售单初始化编辑状态
           self.setSaleTypeItemDisabled(viewmodel.get("saleType").getValue(),viewmodel)
         }
         viewmodel.get("receipttype").setDisabled(true);
         viewmodel.get("receipttype_name").setDisabled(true);
         viewmodel.get("receipttype_code").setDisabled(true);
        });

       viewmodel.get('receipttype_name').on('afterValueChange', function(data) {

             if (!data.value) return;
              self.setItemVisible(data.value.code,viewmodel)
              if(data.value.code=="A01")
              {
                 self.setSaleTypeItemDisabled( viewmodel.get("saleType").getValue(),viewmodel)
              }
       // cb.utils.alert('hello��', 'warning');

        });
        viewmodel.get('MinPercentGiveMoneyPre').on('afterValueChange', function(data) {
          
                       if (!data.value) return;
                        self.setMinPercentGiveMoneyRang(data.value,viewmodel)
                 // cb.utils.alert('hello��', 'warning');
          
                  });
        
      //viewmodel.on("beforeEdit", function (data) {
       // if(viewmodel.get("isSystem").getValue())
        //{
         // cb.utils.alert('预置数据不能修改','warning');
         // return false;
        //}

      //});
      viewmodel.get('saleType').on('afterValueChange', function(data) {
        if (!data.value) return;

        self.setSaleTypeItemDisabled(data.value.value,viewmodel)
        
        // cb.utils.alert('hello��', 'warning');
      });
      },
    setItemVisible: function (code,viewmodel) {

                viewmodel.get("saleType").setVisible(false);
                viewmodel.get("isPreCalcBalance").setVisible(false);
                viewmodel.get("isDistribCenter").setVisible(false);
                viewmodel.get("isDefault").setVisible(false);
                viewmodel.get("isUpdItemBySend").setVisible(false);
                
                viewmodel.get("MinPercentGiveMoneyPre").setVisible(false);
                viewmodel.get("storeType").setVisible(false);
                viewmodel.get("isSaveAndAudit").setVisible(false);
                viewmodel.get("storeOutType").setVisible(false);
                viewmodel.get("storeInType").setVisible(false);
                viewmodel.get("otherOutType").setVisible(false);
                viewmodel.get("otherInType").setVisible(false);
                viewmodel.get("requireItemModel").setVisible(false);
                viewmodel.get("noticeModel").setVisible(false);
                viewmodel.get("allocateModel").setVisible(false);
                viewmodel.get("erpCode").setVisible(false);
                viewmodel.get("checkType").setVisible(false);
                viewmodel.get("bPurchaseAmountSend").setVisible(false);
                
              if (code== "A01") {
                  //零售单
                    viewmodel.get("saleType").setVisible(true);
                    //影响可用量
                    viewmodel.get("isPreCalcBalance").setVisible(true);
                    viewmodel.get("isDistribCenter").setVisible(true);
                    viewmodel.get("isUpdItemBySend").setVisible(true);
                    viewmodel.get("isDefault").setVisible(true);
                    viewmodel.get("MinPercentGiveMoneyPre").setVisible(true);
                    viewmodel.get("storeType").setVisible(true);
                    viewmodel.get("erpCode").setVisible(true);
                   // viewmodel.get("storeType").setValue("1");

                }
                else if (code== "A02" ) {
                //要货申请 调拨申请  退货申请 保存即审核：默认
//|| code=== "A03" || code=== "A04" 
                viewmodel.get("requireItemModel").setVisible(true);
                viewmodel.get("erpCode").setVisible(true);
                //viewmodel.get("requireItemModel").setValue("1");
                   // viewmodel.get("isSaveAndAudit").setVisible(true);
                   // viewmodel.get("isDefault").setVisible(true);
                }
                 else if (code== "A04" ) {
                  viewmodel.get("erpCode").setVisible(true);
                 }
                 else if (code== "A05"  ) {
                   //入库通知单   
                   viewmodel.get("noticeModel").setVisible(true);
                   viewmodel.get("erpCode").setVisible(true);
                   //viewmodel.get("noticeModel").setValue("1");
                  //viewmodel.get("isPreCalcBalance").setVisible(true);
                  //viewmodel.get("isDefault").setVisible(true);
                }
                else if ( code== "A06"  ) {
                  //   出库通知单
                 //viewmodel.get("isPreCalcBalance").setVisible(true);
                 viewmodel.get("isDefault").setVisible(true);
                 viewmodel.get("erpCode").setVisible(true);
               }
                 else if (code== "A07" ) {
                //店存入库
                   viewmodel.get("storeInType").setVisible(true);
                   //viewmodel.get("storeInType").setValue("1");
                   // viewmodel.get("isSaveAndAudit").setVisible(true);
                    viewmodel.get("erpCode").setVisible(true);
                    //viewmodel.get("isDefault").setVisible(true);
                }
                else if (code== "A08" ) {
                // 其他入库
                   viewmodel.get("otherInType").setVisible(true);
                  // viewmodel.get("otherInType").setValue("1");
                   // viewmodel.get("isSaveAndAudit").setVisible(true);
                    viewmodel.get("erpCode").setVisible(true);
                   // viewmodel.get("isSaveAndAudit").setValue("1");
                   // viewmodel.get("isDefault").setVisible(true);
                }
                 else if (code== "A09" ) {
                // 店存出库
                   viewmodel.get("storeOutType").setVisible(true);
                   //viewmodel.get("storeOutType").setValue("1");
                   // viewmodel.get("isSaveAndAudit").setVisible(true);
                    //viewmodel.get("isSaveAndAudit").setValue("1");
                    viewmodel.get("erpCode").setVisible(true);
                    //viewmodel.get("isDefault").setVisible(true);
                }
                  else if (code== "A10" ) {
                // 其他出库
                   viewmodel.get("otherOutType").setVisible(true);
                  // viewmodel.get("otherOutType").setValue("1");
                    //viewmodel.get("isSaveAndAudit").setVisible(true);
                    viewmodel.get("erpCode").setVisible(true);
                  //  viewmodel.get("isSaveAndAudit").setValue("1");
                   // viewmodel.get("isDefault").setVisible(true);
                }
                else if (code== "A13" ) {
                  viewmodel.get("checkType").setVisible(true);
                }
                else if (code== "A15" ) {
                  viewmodel.get("bPurchaseAmountSend").setVisible(true);
                  viewmodel.get("erpCode").setVisible(true);
                  viewmodel.get("isDefault").setVisible(true);
                }
            },
    setSaleTypeItemDisabled: function (code,viewmodel) {
                  
                  var boolshow=false;
                  if(code=="2" )
                  {
                    boolshow=true;
                    viewmodel.get('MinPercentGiveMoneyPre').setState('min', 0);
                    viewmodel.get('MinPercentGiveMoneyPre').setState('max', 100);
                  }
                  
               //  viewmodel.get("code").setDisabled(boolshow);
                //  viewmodel.get("name").setDisabled(boolshow);
                  viewmodel.get("isPreCalcBalance").setVisible(boolshow);
                  viewmodel.get("isUpdItemBySend").setVisible(boolshow);
                  viewmodel.get("isDistribCenter").setVisible(boolshow);
                 // viewmodel.get("isDefault").setDisabled(boolshow);
                  viewmodel.get("MinPercentGiveMoneyPre").setVisible(boolshow);
  

            },
            setEditItemDisabled: function (viewmodel) {
              viewmodel.get("receipttype").setDisabled(true);
              viewmodel.get("receipttype_name").setDisabled(true);
              viewmodel.get("receipttype_code").setDisabled(true);
              var boolshow=false;
              if(viewmodel.get("isSystem").getValue() )
              {
                boolshow=true;
              }
              viewmodel.get("code").setDisabled(boolshow);
             // viewmodel.get("name").setDisabled(boolshow);
              viewmodel.get("saleType").setDisabled(boolshow);
              //viewmodel.get("isPreCalcBalance").setDisabled(boolshow);
             // viewmodel.get("isDistribCenter").setDisabled(boolshow);
             // viewmodel.get("isDefault").setDisabled(boolshow);
              //viewmodel.get("isUpdItemBySend").setDisabled(boolshow);
              
              //viewmodel.get("MinPercentGiveMoneyPre").setDisabled(boolshow);
              //viewmodel.get("storeType").setDisabled(boolshow);
             // viewmodel.get("isSaveAndAudit").setDisabled(boolshow);
              viewmodel.get("storeOutType").setDisabled(boolshow);
              viewmodel.get("storeInType").setDisabled(boolshow);
              viewmodel.get("otherOutType").setDisabled(boolshow);
              viewmodel.get("otherInType").setDisabled(boolshow);
              viewmodel.get("requireItemModel").setDisabled(boolshow);
              viewmodel.get("noticeModel").setDisabled(boolshow);
              viewmodel.get("allocateModel").setDisabled(boolshow);
              viewmodel.get("checkType").setDisabled(boolshow);
        },
            setMinPercentGiveMoneyRang: function (code,viewmodel) {
              var boolshow=true;
              if(code !="" && (parseFloat(code)<0 ||parseFloat(code)>100))
              {
                cb.utils.alert('预订交款比例输入范围[0,100]','warning');
                 return false;
              }
              return true;
            
        },
        setCheckMustInput: function (code,viewmodel) {
          debugger
          if (code=== "A01") {
            //零售单
              if(typeof(viewmodel.get("saleType").getValue())=="undefined" || viewmodel.get("saleType").getValue()=="")
              {
                cb.utils.alert('请选择销售模式','warning');
                 return false;
              }
              if(typeof(viewmodel.get("storeType").getValue())=="undefined" || viewmodel.get("storeType").getValue()=="")
              {
                cb.utils.alert('请选择适用门店','warning');
                 return false;
              }
              if(viewmodel.get("saleType").getValue()=="2"){
                if((typeof(viewmodel.get("isDistribCenter").getValue())=="undefined" || viewmodel.get("storeType").getValue()=="" || viewmodel.get("storeType").getValue()=="0"  ))
                {
                  cb.utils.alert('请选择提货方式','warning');
                  return false;
                }else{
                  var dselevalues=viewmodel.get("isDistribCenter").getValue();
                  if(dselevalues.length==0 || (dselevalues.length==1 &&  dselevalues[0]=="")){
                    cb.utils.alert('请选择提货方式','warning');
                    return false;
                  }
                }

              }
              
          }
          else if (code=== "A02" ) {
          //要货申请 调拨申请  退货申请 保存即审核：默认
            if(typeof(viewmodel.get("requireItemModel").getValue())=="undefined" ||  viewmodel.get("requireItemModel").getValue()=="")
            {
              cb.utils.alert('请选择要货类型','warning');
              return false;
            }
          }
           else if (code== "A05"  ) {
             //入库通知单   
             if(typeof(viewmodel.get("noticeModel").getValue())=="undefined" || viewmodel.get("noticeModel").getValue()=="")
             {
               cb.utils.alert('请选择通知类型','warning');
               return false;
             }
          }
           else if (code== "A07" ) {
          //店存入库
             if(typeof(viewmodel.get("storeInType").getValue())=="undefined" || viewmodel.get("storeInType").getValue()=="")
             {
               cb.utils.alert('请选择入库类型','warning');
               return false;
             }
          }
          else if (code== "A08" ) {
          // 其他入库
             if(typeof(viewmodel.get("otherInType").getValue())=="undefined" || viewmodel.get("otherInType").getValue()=="")
             {
               cb.utils.alert('请选择入库类型','warning');
               return false;
             }
          }
           else if (code== "A09" ) {
          // 店存出库
             if(typeof(viewmodel.get("storeOutType").getValue())=="undefined" || viewmodel.get("storeOutType").getValue()=="")
             {
               cb.utils.alert('请选择出库类型','warning');
               return false;
             }
          }
            else if (code== "A10" ) {
          // 其他出库
             if(typeof(viewmodel.get("otherOutType").getValue())=="undefined" || viewmodel.get("otherOutType").getValue()=="")
             {
               cb.utils.alert('请选择出库类型','warning');
               return false;
             }
          }
          else if (code== "A13" ) {
            // 其他出库
               if(typeof(viewmodel.get("checkType").getValue())=="undefined" || viewmodel.get("checkType").getValue()=="")
               {
                 cb.utils.alert('请选择盘点类型','warning');
                 return false;
               }
            }
          return true;
    }
  }
  try {
    module.exports = AA_aa_businesstype_VM_extend;
  } catch (error) {

  }
  return AA_aa_businesstype_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_businesstype_VM.Extend.js


// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_businesstype_VM.Extend.js